// @flow
import { set } from 'lodash';

/**
 * This helps constructing the initial object from the metada to feed the JsonForm's
 * initial value while creating a new item.
 *
 * If we just give the initial value as `{}` then the validation won't work properly.
 * To address this problem this util is beigng used.
 *
 * Refer :- https://github.com/ajv-validator/ajv/issues/1710. (JsonForms uses Ajv for validation).
 * @param {*} metadata settings metadata from api
 */
export const getInitalFormValue = (
    element: $FixMe,
    res: $FixMe = {}
): $FixMe => {
    if (element.elements) {
        element.elements.forEach(elm => getInitalFormValue(elm, res));
        return res;
    }

    const { path } = element.data || {};

    if (path?.split('.').length > 1) {
        set(res, path, undefined);
    }
};
